__turbopack_context__.v({
  "actions": "DrawingEditor-module-scss-module__VhMxbq__actions",
  "canvasArea": "DrawingEditor-module-scss-module__VhMxbq__canvasArea",
  "canvasContainer": "DrawingEditor-module-scss-module__VhMxbq__canvasContainer",
  "colorPickerContent": "DrawingEditor-module-scss-module__VhMxbq__colorPickerContent",
  "colorPickerHeader": "DrawingEditor-module-scss-module__VhMxbq__colorPickerHeader",
  "colorPickerLabel": "DrawingEditor-module-scss-module__VhMxbq__colorPickerLabel",
  "colorPickerPopover": "DrawingEditor-module-scss-module__VhMxbq__colorPickerPopover",
  "colorSection": "DrawingEditor-module-scss-module__VhMxbq__colorSection",
  "crosshairCursor": "DrawingEditor-module-scss-module__VhMxbq__crosshairCursor",
  "customColorButton": "DrawingEditor-module-scss-module__VhMxbq__customColorButton",
  "eraserIndicator": "DrawingEditor-module-scss-module__VhMxbq__eraserIndicator",
  "header": "DrawingEditor-module-scss-module__VhMxbq__header",
  "headerTitle": "DrawingEditor-module-scss-module__VhMxbq__headerTitle",
  "hexInput": "DrawingEditor-module-scss-module__VhMxbq__hexInput",
  "mobileLayout": "DrawingEditor-module-scss-module__VhMxbq__mobileLayout",
  "modal": "DrawingEditor-module-scss-module__VhMxbq__modal",
  "shapeGridButton": "DrawingEditor-module-scss-module__VhMxbq__shapeGridButton",
  "shapeGridButtonActive": "DrawingEditor-module-scss-module__VhMxbq__shapeGridButtonActive",
  "shapeGridLabel": "DrawingEditor-module-scss-module__VhMxbq__shapeGridLabel",
  "shapesGrid": "DrawingEditor-module-scss-module__VhMxbq__shapesGrid",
  "sizeButton": "DrawingEditor-module-scss-module__VhMxbq__sizeButton",
  "sizePopover": "DrawingEditor-module-scss-module__VhMxbq__sizePopover",
  "sizePopoverContent": "DrawingEditor-module-scss-module__VhMxbq__sizePopoverContent",
  "sizePopoverHeader": "DrawingEditor-module-scss-module__VhMxbq__sizePopoverHeader",
  "sizePopoverLabel": "DrawingEditor-module-scss-module__VhMxbq__sizePopoverLabel",
  "sizePopoverValue": "DrawingEditor-module-scss-module__VhMxbq__sizePopoverValue",
  "sizePresetButton": "DrawingEditor-module-scss-module__VhMxbq__sizePresetButton",
  "sizePresetButtonActive": "DrawingEditor-module-scss-module__VhMxbq__sizePresetButtonActive",
  "sizePresets": "DrawingEditor-module-scss-module__VhMxbq__sizePresets",
  "textCursor": "DrawingEditor-module-scss-module__VhMxbq__textCursor",
  "textInputField": "DrawingEditor-module-scss-module__VhMxbq__textInputField",
  "textInputOverlay": "DrawingEditor-module-scss-module__VhMxbq__textInputOverlay",
  "toolButton": "DrawingEditor-module-scss-module__VhMxbq__toolButton",
  "toolButtonActive": "DrawingEditor-module-scss-module__VhMxbq__toolButtonActive",
  "toolbar": "DrawingEditor-module-scss-module__VhMxbq__toolbar",
  "toolbarArea": "DrawingEditor-module-scss-module__VhMxbq__toolbarArea",
  "toolbarInner": "DrawingEditor-module-scss-module__VhMxbq__toolbarInner",
  "toolbarInnerMobile": "DrawingEditor-module-scss-module__VhMxbq__toolbarInnerMobile",
  "toolbarSection": "DrawingEditor-module-scss-module__VhMxbq__toolbarSection",
  "toolbarSectionPadded": "DrawingEditor-module-scss-module__VhMxbq__toolbarSectionPadded",
});
